import MenuItem, { LinkContainer } from "@components/MenuItem"
import MenuItemExpandable, {
  anchorStylesSideNav,
  anchorStylesSideNavItem,
} from "@components/MenuItemExpandable"
import { getIn } from "@utils/index"
import { MenuDataProps } from "@utils/types"
import { getShopURLForDevice } from "@utils/urls"
import * as R from "ramda"
import React from "react"
import styled from "styled-components"

const Container = styled.div`
  overflow: hidden;

  ${LinkContainer} {
    padding: 18px 10px 18px 20px;
  }
`

interface DeviceFilterProps {
  brandSlug
  data: MenuDataProps
  deviceTypeSlug
}

const DeviceFilter: React.FC<DeviceFilterProps> = ({
  brandSlug,
  data,
  deviceTypeSlug,
}) => {
  const formatDevice = ({ name, slug }) => ({
    label: name,
    link: getShopURLForDevice(slug),
  })

  const allBrands = getIn(data, `${deviceTypeSlug}.brands`, [])
  const brandData = R.find(
    (brand: any) => brandSlug === brand.brandSlug,
    allBrands
  )
  const devices = getIn(brandData, "devices", [])
  const devicesToShow = getIn(brandData, "devicesToShow")
  const formattedDevices = React.useMemo(
    () => devices.map(formatDevice),
    [data]
  )

  const renderedDevices = devicesToShow
    ? R.slice(0, devicesToShow, formattedDevices)
    : formattedDevices
  const expandableDevices: any = devicesToShow
    ? R.slice(devicesToShow, formattedDevices.length, formattedDevices)
    : []

  const uniqDevices = R.uniqBy(({ link }) => link, renderedDevices) as any

  return (
    <Container>
      {uniqDevices.map((props) => (
        <MenuItem key={props.label} {...props} />
      ))}
      {expandableDevices.length > 0 && (
        <MenuItemExpandable
          anchorContainerStyles={anchorStylesSideNav}
          anchorItemStyles={anchorStylesSideNavItem}
          items={expandableDevices}
          label={`View ${expandableDevices.length} More`}
        />
      )}
    </Container>
  )
}

export default DeviceFilter
